import { action as apiAction } from 'api/Api'
import {
  setPosition
} from '../redux/elements'
import { optimisticDispatch } from 'utils/sagas'

type Payload = {
  cardId: number
  elementId: number
  position: number
}

const requestPositionElement = (payload: Payload) => async dispatch => {
  const { cardId, elementId, position } = payload

  const optimisticAction = optimisticDispatch(dispatch, setPosition({
    cardId,
    elementId,
    index: position
  }))

  try {
    await apiAction('PositionElement', {
      id: elementId,
      position
    })

    optimisticAction.commit()
  } catch (error) {
    optimisticAction.revert()

    throw error
  }
}

export default requestPositionElement
